import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { omit } from 'lodash'

import auth from './auth'
import product from './product'
import job from './job'
import chat from './chat'
import supplier from './supplier'
import payment from './payment'
import settings from './settings'
import category from './category'
import pinch_payment from './pinch_payment'

import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const allowedTypes = [
  'auth/SET_TOKEN',
  'auth/LOGOUT'
]

const setRequestHeaders = (state) => {
  const { token } = state.auth
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

const Plugins = {
  request: (store) => {
    setRequestHeaders(store.state)

    store.subscribe((mutation, state) => {
      if (state.auth.token) {
        window.Echo.connector.options.auth.headers['Authorization'] = `Bearer ${state.auth.token}`
      }

      if (allowedTypes.indexOf(mutation.type) !== -1) {
        setRequestHeaders(state)
      }
    })
  },

  jobForm: createPersistedState({
    reducer(state) {
      const { job } = state
      return {
        // Indicate states that should not be persisted
        job: omit(job, [
          'jobs',
          'site_restrictions',
          'logistics',
          'bidcrete_phone_number',
          'bidcrete_email_address',
        ]),
      }
    }
  })
}

const store = new Vuex.Store({
  strict: process.env.NODE_ENV === 'production',
  modules: {
    auth,
    product,
    job,
    chat,
    supplier,
    payment,
    pinch_payment,
    settings,
    category
  },
  plugins: [
    Plugins.request,
    Plugins.jobForm
  ]
})

export default store